export enum IpaasPlatform {
  ZAPIER,
  WORKATO,
  TRAY_IO,
  TENFOLD,
  PIESYNC,
  PIPEDREAM,
}
